export const monthOptions = [
	[1, "January"], [2, "February"], [3, "March"], [4, "April"], [5, "May"], [6, "June"],
	[7, "July"], [8, "August"], [9, "September"], [10, "October"], [11, "November"], [12, "December"],
] as const;

export const weekdayOptions = [
	["monday", "Monday"], ["tuesday", "Tuesday"], ["wednesday", "Wednesday"], ["thursday", "Thursday"],
	["friday", "Friday"], ["saturday", "Saturday"], ["sunday", "Sunday"],
] as const;

export function celsiusToFahrenheit(value: number): number {
	return Math.round((value * 9 / 5 + 32) * 10) / 10;
}

export function fahrenheitToCelsius(value: number): number {
	return Math.round(((value - 32) * 5 / 9) * 10) / 10;
}

export function toggleValue<T>(values: T[], value: T, enabled: boolean): T[] {
	return enabled ? Array.from(new Set([...values, value])) : values.filter((item) => item !== value);
}

export function localDateTimeValue(value?: string | null): string {
	if (!value) return "";
	const parsed = new Date(value);
	if (Number.isNaN(parsed.getTime())) return "";
	const offset = parsed.getTimezoneOffset() * 60_000;
	return new Date(parsed.getTime() - offset).toISOString().slice(0, 16);
}

export function humanDuration(seconds: number): string {
	if (seconds <= 0) return "Off";
	const minutes = Math.ceil(seconds / 60);
	if (minutes < 60) return `${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
	const hours = Math.floor(minutes / 60);
	const remainder = minutes % 60;
	if (hours < 24) return remainder ? `${hours}h ${remainder}m` : `${hours} ${hours === 1 ? "hour" : "hours"}`;
	const days = Math.floor(hours / 24);
	return `${days} ${days === 1 ? "day" : "days"}`;
}

export function programFrequencyParam(frequency: string): string {
	switch (frequency) {
		case "weekdays": return "01111100";
		case "interval": return "2";
		case "odd": return "1";
		case "daily":
		case "even":
		default: return "0";
	}
}
